import { Shimmer } from '@components/Shimmer'
import { Stack, XStack, YStack } from 'tamagui'

export function PathGhostLoading() {
  return (
    <YStack testID="path-ghost-loading">
      <Stack
        flexDirection="column"
        marginBottom={40}
        marginTop={100}
        p={'$size.spacing-xs'}
      >
        <Stack>
          <YStack alignSelf="baseline" gap={20}>
            <Shimmer width={100} height={16} />
            <Shimmer width={250} height={35} />
          </YStack>
        </Stack>
      </Stack>
      <YStack gap={20} bg="$background-100" p="$size.spacing-xs" flex={1}>
        <Shimmer width={250} height={30} />
        <XStack gap={16}>
          <Shimmer width={250} height={150} />
          <Shimmer width={250} height={150} />
        </XStack>
      </YStack>
    </YStack>
  )
}
